<template>
  <g>
    <path
      d="M5.33929 4.4679H7.33929V7.02499C8.52931 6.0899 10.0299 5.5322 11.6607 5.5322C15.5267 5.5322 18.6607 8.6662 18.6607 12.5322C18.6607 16.3982 15.5267 19.5322 11.6607 19.5322C9.51025 19.5322 7.58625 18.5625 6.30219 17.0364L7.92151 15.8516C8.83741 16.8826 10.1732 17.5322 11.6607 17.5322C14.4222 17.5322 16.6607 15.2936 16.6607 12.5322C16.6607 9.77077 14.4222 7.5322 11.6607 7.5322C10.5739 7.5322 9.56805 7.87896 8.74779 8.4679L11.3393 8.4679V10.4679H5.33929V4.4679Z"
      fill="currentColor"
    />
  </g>
</template>
